import script from "./ProUpgradeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProUpgradeModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProUpgradeModal.vue?vue&type=style&index=0&id=80c39cac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80c39cac"]])

export default __exports__